import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';

const API = "https://labwayscientific.com/backend/wp-json/wc/v3";
const CK = "ck_e1c36267e6a5e3cb0198558262bf2096181b4a0b";
const CS = "cs_fc900ba31d63fade2cfba415abe8a599366c20b0";

function Topmenuleft() {
  const [categories, setCategories] = useState([]);
  const location = useLocation();

  useEffect(() => {
    fetch(`${API}/products/categories?per_page=100&consumer_key=${CK}&consumer_secret=${CS}`)
      .then(res => res.json())
      .then(data => setCategories(data));
  }, []);

  // 👉 Parent categories
  const parentCats = categories.filter(cat => cat.parent === 0);

  // 👉 Get subcategories
  const getSubCats = (parentId) => {
    return categories.filter(cat => cat.parent === parentId);
  };

  const isHomeActive = location.pathname === '/' || location.pathname === '/home';
  const isProductsActive =
    location.pathname === '/shop' ||
    location.pathname.startsWith('/category/') ||
    location.pathname.startsWith('/product/');
  const isAboutActive = location.pathname === '/about';
  const isContactActive = location.pathname === '/contact';

  return (
    <nav className="navbar navbar-expand-lg">

      <div className="collapse navbar-collapse">
        <ul className="navbar-nav">

          <li className="nav-item">
            <NavLink
              className={`nav-link${isHomeActive ? ' active' : ''}`}
              to="/home"
            >
              Home
            </NavLink>
          </li>

         

          {/* 🔥 SHOP DROPDOWN WITH SUBCATEGORY */}
          <li className={`nav-item dropdown${isProductsActive ? ' active' : ''}`}>
            <NavLink
              className={`nav-link dropdown-toggle${isProductsActive ? ' active' : ''}`}
              to="/shop"
            >
              Products
            </NavLink>

            <ul className="dropdown-menu">

              {parentCats.map(parent => (
                <li key={parent.id} className="dropdown-submenu">

                  {/* Parent */}
                  <Link className="dropdown-item" to={`/category/${parent.id}`}>
                    {parent.name}
                  </Link>

                  {/* Subcategories */}
                  {getSubCats(parent.id).length > 0 && (
                    <ul className="dropdown-menu">

                      {getSubCats(parent.id).map(sub => (
                        <li key={sub.id}>
                          <Link className="dropdown-item" to={`/category/${sub.id}`}>
                            {sub.name}
                          </Link>
                        </li>
                      ))}

                    </ul>
                  )}

                </li>
              ))}

            </ul>
          </li>

           <li className="nav-item">
            <NavLink
              className={`nav-link${isAboutActive ? ' active' : ''}`}
              to="/about"
            >
              About Us
            </NavLink>
          </li>

          {/* <li className="nav-item">
            <Link className='nav-link' to='#'>Search Alphabetically</Link>
          </li> */}

            <li className="nav-item">
            <Link className='nav-link' to='/gallery'>Gallery</Link>
          </li>

        

           <li className="nav-item">
            <NavLink
              className={`nav-link${isContactActive ? ' active' : ''}`}
              to="/contact"
            >
              Contact Us
            </NavLink>
          </li>

        </ul>
      </div>

    </nav>
  );
}

export default Topmenuleft;
